import { render, staticRenderFns } from "./kuaidi100.vue?vue&type=template&id=161a3c92&"
import script from "./kuaidi100.vue?vue&type=script&lang=js&"
export * from "./kuaidi100.vue?vue&type=script&lang=js&"
import style0 from "./kuaidi100.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports